import { firstValueFrom } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PackagingLevelsDto } from '../core-data/packaging-levels-dto';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class CoreDataUpdateService {

  private _allPackagingLevels: PackagingLevelsDto[];

  constructor(
    private http: HttpClient,
  ) {
    this._allPackagingLevels = [];
  }

  get allPackagingLevels() : PackagingLevelsDto[] {
    return this._allPackagingLevels
  }

  public async updateCoreData() {
      this._allPackagingLevels = await this.getAllPackagingLevels();
  }

  public async getAllPackagingLevels() : Promise<PackagingLevelsDto[]> {
    const url =  `${environment.webApiAddress}/api/packaging-levels`;
    return firstValueFrom(this.http.get<PackagingLevelsDto[]>(url));
  }

}
